import { useState, useEffect } from 'react';
import { getStorage } from '@spa/shared/utils/storage';

export const useStorage = key => {
  const [storage, setStorage] = useState(getStorage(key));

  useEffect(() => {
    setStorage(getStorage(key));
  }, []);

  return storage;
};
